import React from 'react';
import {
  NativeSyntheticEvent,
  StyleSheet,
  TextInput,
  TextInputChangeEventData,
  TextInputFocusEventData,
  TextInputProps,
} from 'react-native';

import {colors} from '../../styles';
import {styles as textStyles} from '../Typography';
import {InputContext} from './InputContainer';

export interface InputProps extends Omit<TextInputProps, 'children'> {}

export const Input: React.FC<InputProps> = ({style, ...props}) => {
  const inputContext = React.useContext(InputContext);

  const onFocus = (event: NativeSyntheticEvent<TextInputFocusEventData>) => {
    inputContext?.onFocusChange(true);
    props.onFocus?.(event);
  };

  const onBlur = (event: NativeSyntheticEvent<TextInputFocusEventData>) => {
    inputContext?.onFocusChange(false);
    props.onBlur?.(event);
  };

  const onChangeText = (text: string) => {
    props.onChangeText?.(text);

    props.onChange?.(
      text as unknown as NativeSyntheticEvent<TextInputChangeEventData>,
    );
  };

  return (
    <TextInput
      allowFontScaling={false}
      autoCorrect={false}
      placeholderTextColor={colors.disabledTextGray}
      selectionColor={colors.disabledTextGray}
      underlineColorAndroid="transparent"
      cursorColor={colors.white}
      style={[styles.input, textStyles.body, style]}
      {...props}
      {...{onFocus, onBlur, onChangeText}}
    />
  );
};

const styles = StyleSheet.create({
  input: {
    flex: 1,
    color: colors.white,
    paddingVertical: 0,
  },
});
